'use client'

import React, { createContext, ReactNode, useMemo, useState } from 'react'
import { DefaultTimelineRemarkData, FileData } from '../types/TimelineRemarkTypes'
import { TimelineContexts } from '../types/TimelineEventTypes'

export type TimelineProviderModel = {
    defaultRemarkData: DefaultTimelineRemarkData | null
    remarkFileDestinationType: number | null
    timelineContext: TimelineContexts
    documentFieldValue: FileData | null
    setDocumentFieldValue: (fileData: FileData | null) => void
    downloadAttachmentHandler?: (fileData: FileData) => void
    isProcessingFile: boolean
    setIsProcessingFile: (isProcessingFile: boolean) => void
}

export const TimelineProviderContext = createContext<TimelineProviderModel>({} as TimelineProviderModel)

interface Props {
    children: ReactNode
    defaultRemarkData?: DefaultTimelineRemarkData
    remarkFileDestinationType?: number
    timelineContext: TimelineContexts
    downloadAttachmentHandler?: (fileData: FileData) => void
}

export const TimelineProvider = ({
    children,
    defaultRemarkData,
    remarkFileDestinationType,
    timelineContext,
    downloadAttachmentHandler,
}: Props) => {
    const [documentFieldValue, setDocumentFieldValue] = useState<FileData | null>(null)
    const [isProcessingFile, setIsProcessingFile] = useState<boolean>(false)

    const providerValue: TimelineProviderModel = useMemo(
        () => ({
            defaultRemarkData: defaultRemarkData || null,
            remarkFileDestinationType: remarkFileDestinationType || null,
            timelineContext,
            documentFieldValue,
            setDocumentFieldValue,
            downloadAttachmentHandler,
            isProcessingFile,
            setIsProcessingFile,
        }),
        [
            defaultRemarkData,
            remarkFileDestinationType,
            timelineContext,
            documentFieldValue,
            setDocumentFieldValue,
            isProcessingFile,
            setIsProcessingFile,
        ],
    )

    return <TimelineProviderContext.Provider value={providerValue}>{children}</TimelineProviderContext.Provider>
}
